import React from 'react';

import { AnalysesContextTypes } from './types';

export const AnalysesContext = React.createContext<AnalysesContextTypes<any> | null>(null);
